import { FC, useEffect, useState } from "react";
import { useStreak } from "./StreakContextType";
import { StreakCounterProps } from "../component/StreakTypes";
import { extractGradientColors } from "../../../../general";

export const StreakTimer: FC<StreakCounterProps> = () => {
    const { days, stepDetails, themeManager } = useStreak();
    const [timeRemaining, setTimeRemaining] = useState<string>("");
    const [progress, setProgress] = useState<number>(0);

    useEffect(() => {
        if (!stepDetails) return;

        const nextMilestone = stepDetails.find((step) => step.range > days);
        if (!nextMilestone) return;

        const now = new Date();
        const nextDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        nextDate.setUTCDate(now.getUTCDate() + (nextMilestone.range - days));
        nextDate.setUTCHours(0, 0, 0, 0);

        const updateTimer = () => {
            const now = new Date();
            const targetTime = nextDate.getTime();
            const diff = targetTime - now.getTime();

            if (diff <= 0) {
                setTimeRemaining("Completed");
                setProgress(100);
                return;
            }

            const startOfDay = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            const totalDayMs = 24 * 60 * 60 * 1000;
            const elapsedMs = now.getTime() - startOfDay.getTime();
            setProgress((elapsedMs / totalDayMs) * 100);

            const minutes = Math.floor(diff / (1000 * 60));
            if (minutes < 60) {
                setTimeRemaining(`${minutes} mins`);
            } else if (minutes < 1440) {
                setTimeRemaining(`${Math.floor(minutes / 60)} hr ${minutes % 60} mins`);
            } else {
                setTimeRemaining(`${Math.floor(minutes / 1440)} day ${Math.floor((minutes % 1440) / 60)} hr`);
            }
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [days, stepDetails]);

    if (days >= stepDetails[stepDetails.length - 1].range) return null;

    return (
        <div className="q_streak_timer" style={themeManager.getTimestampStyles()}>
            <p style={themeManager.getStreakHeadingStyles()}>Time Remaining: {timeRemaining}</p>
            <div className="q_streak_progress_bar" style={{ background: themeManager.getProgressBarBg() }}>
                <div
                    style={{
                        width: `${progress}%`,
                        background: themeManager.getProgressBarFill()?.includes("gradient") ? extractGradientColors(
                            themeManager.getProgressBarFill()
                        ) : themeManager.getProgressBarFill(),
                        borderRadius: "4px"
                    }}
                    className="q_streak_progress_bar_inner"
                />
            </div>
        </div>
    );
};
